
import { Options, Vue } from "vue-class-component"; //基本需要
import SideMenu from "@/components/WorkBench/SideMenu.vue"; //导入组件SideMenu:1
import {
  dateConversion,
  getLocalProject,
  saveLocalProject,
  saveLocalStorageProject,
  typeConversion,
  unique_json,
} from "@/utils"; //类型
import { ElMessage } from "element-plus";
import * as echarts from "echarts";
import { store } from "@/store"; //引入仓库
import {
  readDateVersions,
  readNewReport,
  readNewReportList,
  readPerformances,
  readPerformanceSelectOptions,
  readPerfReport,
  readTaskRecordDevices,
  readTaskRecordQuery,
  readPerformanceVersion,
} from "@/store/performance/getters"; //引入仓库接口
import {
  dispatchCreateReport,
  dispatchGetPerfReport,
  dispatchGetPerformanceSelectOptions,
  dispatchGetReportDetail,
  dispatchGetPerformances,
  dispatchUploadReportImage,
  dispatchtaskRecordQuery,
  dispatchtaskRecordDevices,
  dispatchAovCopyPerfToReport,
  dispatchGetNewReportList,
  dispatchDeleteReport,
  dispatchGetDateVersionList,
  dispatchGetPerformanceVersion,
  dispatchClearCache,
} from "@/store/performance/actions";
import { readDeviceSpecs } from "@/store/device/getters";
import { dispatchGetDeviceSpecs } from "@/store/device/actions";
import {
  dispatchGetProjectDetail,
  dispatchGetProjectScenes,
} from "@/store/project/actions";
import { fontWeight } from "html2canvas/dist/types/css/property-descriptors/font-weight";
import { number } from "echarts";
import _FormItem from "element-plus/lib/el-form-item";
import {
  readHeroSkin,
  readMobaProjects,
  readUserProfile,
} from "@/store/main/getters";
import {
  dispatchGetHeroSkin,
  dispatchGetMobaProjects,
  dispatchUpdateMyLastProject,
} from "@/store/main/actions";
import Log from "../Log.vue";
import { readMyProjects, readProjectDetail } from "@/store/project/getters";

// 导入组件SideMenu:2
@Options({
  components: {
    SideMenu,
  },
})
export default class TestReport extends Vue {
  //export default必不可少，否则会报错哦

  // 声明属性
  public dialogFormVisible = false; // 生成报告的弹窗是否可见
  public generateReportVersion = {
    // 弹窗内——生成报告的新/旧版本
    oldEdition: "",
    newEdition: "",
    scenetion: [],
  };
  public report_name_placeholder = "【GR自动化性能】项目名-新版本号"; //弹窗内默认项目名称

  public localProject = Number(getLocalProject()); //得到本地的项目
  public report_id = 0; //报告的id
  public com_risk = "低风险"; //共同风险
  public new_report: any = {
    //新报告需要的数据类型
    id: 0,
    new_version: "",
    old_version: "",
    test_info: "",
    risk: null,
    create_date: "",
    settings: JSON.stringify({
      rule_settings: {
        change_rule: {
          increase_good: ["avg_fps"],
          threshold: {},
        },
        risk_rule: {},
        tdr_risk_rule: {},
      },
      report_settings: {
        content: {
          core_index: ["avg_fps", "max_pss"], //核心指数
          trend_index: ["avg_fps", "max_pss"], //趋势指数
          exclude_scene: [], //排除场景
          exclude_device: [], //排除设备
          show_index: [
            "max_pss",
            "avg_fps",
            "fps_lt_10_pcnt",
            "fps_lt_18_pcnt",
            "fps_lt_25_pcnt",
          ], //显示索引
          index_type: {
            //索引类型
            basic: ["max_pss", "avg_fps"], //基础指标
            advance: ["fps_lt_10_pcnt", "fps_lt_18_pcnt", "fps_lt_25_pcnt"], //深度指标
            customize: [], //定制指标
          },
          trend_number: 10, //趋势指数
          trend_integrity: true, // 趋势图的完整性, 是否允许有缺失数据, 有断点, 1: 允许数据缺失, 0:不允许数据缺失
          red_only_change_value: false, // 是否仅标红变化值, 核心风险详情表格, 里面只标红括号内变化的值
        },
        notify: {
          //通知
          email: {
            enable: false,
            receiver: [], //接收
          },
          wecom: {
            enable: false,
            receiver: [],
          },
          wecom_robot: {
            enable: false,
            receiver: [],
          },
        },
      },
    }),
    creator: "",
  };
  public get_core_data = {
    //获取核心数据的数据类型
    able_versions: {
      android_new_version: "",
      android_old_version: "",
      ios_new_version: "",
      ios_old_version: "",
    },
    report_data: {},
    report_list: [],
    report_list1: [],
    new_version: "",
    old_version: "",
    old_version1: "",
    all_devices: [],
    report_list2: [
      {
        scene_id: 0,
        scene: "",
        old_version: "",
        custom_index: [],
        device_list: [],
        old: [
          {
            data: { url: "", game_version: "" },
          },
        ],
        new: [
          {
            data: { url: "", game_version: "" },
            device: "",
            level: "",
          },
        ],
        standard: [],
      },
    ],
    all_echart_versions: [],
    all_echart_data: [
      { performance_briefs: [{ device_id: 0 }], date_list: [] },
    ],
    project: {
      icon: "",
      project_name: "",
    },
    all_device_id: [],
    str_list: [],
    hero_list: [],
    skin_list: [],
    all_hero_skins: {},
    core_devices1: [],
    core_devices2: [],
  };

  // public report_name_placeholder = "";
  public get_field(field: string) {
    const fields = {
      avg_fps: "平均FPS", // 平均FPS
      max_pss: "PSS峰值", // 峰值PSS
      max_mono_used: "maxMonoUsed(M)", // 峰值Used Mono
      max_mono_total: "峰值mono内存(M)", // 峰值Total Mono
      avg_cpu: "平均CPU", // 平均CPU
      fps_lt_10_pcnt: "FPS<=10占⽐(%)", // FPS<=10占有率(%)
      fps_lt_18_pcnt: "FPS>=18占⽐(%)", // FPS>=18占有率(%)
      fps_lt_25_pcnt: "FPS>=25占⽐(%)", // FPS>=25占有率(%)
      fps_lt_40_pcnt: "FPS>=40占⽐(%)", // FPS>=40占有率(%)
      cpu_lt_60_pcnt: "CPU<=60占⽐(%)", // FPS<=60占有率(%)
      cpu_lt_80_pcnt: "CPU<=80占⽐(%)", // FPS<=80占有率(%)
      dps: "dps",
      avg_dc: "平均DC", // 平均DC
      max_dc: "峰值DrawCall数", // 峰值DC
      max_triangle: "峰值三角形数", // 峰值三角形(万)
      duration: "耗时", // 耗时
      avg_flow: "流量(KB/S)", // 流量(KB/S)
      max_swap: "maxSwap",
      max_vss: "maxVss",
      max_swap_add_pss: "maxSwapAddPss",
      process_up_flow: "进程上行流量[KB/s]",
      process_down_flow: "进程下行流量[KB/s]",
      logic_up_flow: "逻辑上行流量[KB/s]",
      logic_down_flow: "逻辑下行流量[KB/s]",
      lag_cnt: "卡顿次数", // 卡顿次数
      single_peak_lag_cnt: "singlePeakLagCnt",
      multiple_peak_lag_cnt: "multiplePeakLagCnt",
      continue_low_lag_cnt: "continueLowLagCnt",
      lag_pcnt: "卡顿率", // 卡顿率
      lag_freq: "卡顿频率",
      id_row_start: "id_row_start",
      id_row_end: "id_row_end",
      id_frame_start: "id_frame_start",
      id_frame_end: "id_frame_end",
      avg_cpu_total: "avgCpuTotal",
      gc_cnt: "GC(次)", // gc_cnt
      gc_freq: "GC频率",
      cpu_temp: "CPU温度",
    };
    return typeConversion(field, fields); //类型转换
  }
  public loading = false; //加载

  // 取得仓库数据
  public get getDeviceSpecs() {
    // 设备列表
    const devices = readDeviceSpecs(store);
    return devices;
  }
  public get getDateVersions() {
    return readDateVersions(store);
  }
  // public get getPerformanceSelectOptions() {
  //   //获取性能选择选项
  //   return readPerformanceSelectOptions(store);
  // }
  public get getPerformances() {
    //获取性能数据
    const performances: any[] = readPerformances(store);
    return performances;
  }
  public perf_report() {
    //性能报告核心数据
    this.get_core_data = readPerfReport(store);
  }
  public get_create_report() {
    //获取新报告
    this.new_report = readNewReport(store);
    this.new_report.create_date = dateConversion(this.new_report.create_date);
  }
  public generateReportsManually() {
    // 手动生成报告
    this.dialogFormVisible = true;
    this.generateReportVersion.oldEdition = "";
    this.generateReportVersion.newEdition = "";
  }
  public save_report(is_auto?: boolean) {
    //发送报告
    let upload_data: any;
    if (typeof is_auto === "boolean") {
      upload_data = {
        project: this.$route.query.project
          ? this.$route.query.project
          : Number(this.localProject),
        report_id: this.$route.query.report_id
          ? this.$route.query.report_id
          : Number(this.name_search),
        file_list: this.resBase64,
        is_auto: is_auto,
        title: this.formMail.title,
        recv: this.formMail.addressee,
        cc: this.formMail.CC_List,
        send: this.formMail.Sender,
      };
    } else {
      upload_data = {
        project: this.$route.query.project
          ? this.$route.query.project
          : Number(this.localProject),
        report_id: this.$route.query.report_id
          ? this.$route.query.report_id
          : Number(this.name_search),
        file_list: this.resBase64,
        title: this.formMail.title,
        recv: this.formMail.addressee,
        cc: this.formMail.CC_List,
        send: this.formMail.Sender,
      };
    }

    dispatchUploadReportImage(store, upload_data);
    ElMessage({
      //Message 消息提示
      message: "报告发送中...",
      showClose: true,
    });
  }
  public get screenshot() {
    if ("screenshot" in this.$route.query) {
      return false;
    } else {
      return true;
    }
  }

  public resBase64: any[] = [];
  public corePerformance: any[] = [];
  //报告名称
  public name_search = "";

  // 页面初始化
  public async mounted() {
    this.loading = true;
    if (this.$route.query.report_id) {
      if (this.$route.query.project) {
        const project = Number(this.$route.query.project);
        // 记录一下最后访问的项目
        dispatchUpdateMyLastProject(store, { last_visit_project: project });
        saveLocalProject(String(project));
        saveLocalStorageProject(String(project));
        this.reload();
        // 获取当前报告名称列表
        await dispatchGetNewReportList(store, {
          project: this.localProject,
          report_type: 0,
        });
        (this.name_search as any) = Number(this.$route.query.report_id);

        dispatchGetDeviceSpecs(store, {
          project: project,
        });
        // dispatchGetPerformanceSelectOptions(store, {
        //   project: project,
        // });
        dispatchGetDateVersionList(store, {
          project: project,
        });
        await dispatchGetMobaProjects(store, project);
        if (this.projectIsKing) {
          dispatchGetHeroSkin(store, project);
        }
        await dispatchGetReportDetail(store, {
          project: project,
          id: Number(this.$route.query.report_id),
        });
        this.report_id = readNewReport(store).id;
        await dispatchGetPerfReport(store, {
          project: project,
          report_id: Number(this.$route.query.report_id),
        });

        await this.perf_report();
        this.scene_options; //选择场景
        await this.get_create_report(); //启用生成报告的接口
        this.selected_scene =
          (this.get_core_data.all_echart_data as any[])[0]?.scene_id || ""; //场景iD
        if (this.report_set.content.trend_scene) {
          if (this.report_set.content.trend_scene.length !== 0) {
            this.selected_scene = this.report_set.content.trend_scene[0];
          }
        }

        this.resBase64 = [];
        // aov数据
        await this.get_core_data.all_echart_data.map((item, index) => {
          this.performanceTrends_echarts(
            index,
            this.all_device_options[index].label
          ); //图表
        });
        // 从浏览器触发发送报告
        if ("screenshot" in this.$route.query) {
          this.save_report();
        }
      } else {
        dispatchGetDeviceSpecs(store, {
          project: this.localProject,
        });
        // dispatchGetPerformanceSelectOptions(store, {
        //   project: this.localProject,
        // });
        dispatchGetDateVersionList(store, {
          project: this.localProject,
        });
        await dispatchGetMobaProjects(store, this.localProject);
        if (this.projectIsKing) {
          dispatchGetHeroSkin(store, this.localProject);
        }
        await dispatchGetReportDetail(store, {
          project: this.localProject,
          id: Number(this.$route.query.report_id),
        });
        this.report_id = readNewReport(store).id;
        await dispatchGetPerfReport(store, {
          project: this.localProject,
          report_id: Number(this.$route.query.report_id),
        });

        await this.perf_report();
        this.scene_options; //选择场景
        await this.get_create_report(); //启用生成报告的接口
        this.selected_scene =
          (this.get_core_data.all_echart_data as any[])[0]?.scene_id || ""; //场景iD
        if (this.report_set.content.trend_scene) {
          if (this.report_set.content.trend_scene.length !== 0) {
            this.selected_scene = this.report_set.content.trend_scene[0];
          }
        }
        this.resBase64 = [];
        // aov数据
        await this.get_core_data.all_echart_data.map((item, index) => {
          this.performanceTrends_echarts(
            index,
            this.all_device_options[index].label
          ); //图表
        });
      }
    } else {
      // 获取当前报告名称列表
      await dispatchGetNewReportList(store, {
        project: this.localProject,
        report_type: 0,
      });
      // 报告名称
      this.name_search = readNewReportList(store)[0].id;
      this.$router.push({
        query: { ...this.$route.query, report_id: this.name_search },
      });
      // 邮件标题
      this.formMail.title = (readNewReportList(store) as any[]).filter(
        (item: any) => item.id === this.name_search
      )[0].report_name;
      await dispatchGetReportDetail(store, {
        project: this.localProject,
        id: Number(this.name_search),
      });
      await this.addressee; //解析邮件收件人

      this.report_id = readNewReport(store).id;
      await dispatchGetPerfReport(store, {
        project: this.localProject,
        report_id: Number(this.name_search),
      });
      await this.perf_report();
      await this.get_create_report(); //启用生成报告的接口
      await dispatchGetProjectDetail(store, {
        id: this.localProject,
        project: this.localProject,
      });
      this.resBase64 = [];
      // aov数据
      await this.get_core_data.all_echart_data.map((item, index) => {
        this.performanceTrends_echarts(
          index,
          this.all_device_options[index].label
        ); //图表
      });
      await dispatchGetProjectDetail(store, {
        id: this.localProject,
        project: this.localProject,
      });
      dispatchGetDateVersionList(store, {
        project: this.localProject,
      });
      // dispatchGetPerformanceSelectOptions(store, {
      //   project: this.localProject,
      // });
      dispatchGetDeviceSpecs(store, { project: this.localProject });
      await dispatchGetMobaProjects(store, this.localProject);
      if (this.projectIsKing) {
        dispatchGetHeroSkin(store, this.localProject);
      }
      await dispatchGetProjectScenes(store, { project: this.localProject });

      // await dispatchGetPerformances(store, {
      //   project: this.localProject,
      //   task_record_id: "",
      //   scene_id:
      //     readPerformanceSelectOptions(store).scene_list[0]?.scene_id || "",
      //   device_id: "",
      // });
    }
    this.corePerformance = [];
    await this.getCorePerformance();
    await dispatchtaskRecordQuery(store, {
      project: this.localProject,
      task_record_id: "",
    }); //aov复制数据需要的任务记录列表接口
    await dispatchtaskRecordDevices(store, {
      project: this.localProject,
      task_record_id: "",
    }); //获取任务记录的设备
    this.get_core_data.report_list.unshift(this.get_core_data.report_list[0]);
    // await this.scrollBar()//判断是否有滚动条
    await this.noDecimal();
    this.judgeModel;
    this.loading = false;
  }

  // 核心指标性能趋势数据
  public getCorePerformance() {
    if (this.get_core_data.report_list.length > 0) {
      this.corePerformance.push({
        title: "新场景:",
        data: this.get_core_data.report_list,
        compare: this.get_core_data.core_devices1,
        edition: this.get_core_data.old_version,
      });
    }
    if (this.get_core_data.report_list1.length > 0) {
      this.corePerformance.push({
        title: "老场景:",
        data: this.get_core_data.report_list1,
        compare: this.get_core_data.core_devices2,
        edition: this.get_core_data.old_version1,
      });
    }
    return this.corePerformance;
  }

  public get get_hero_skin_config() {
    return readHeroSkin(store);
  }

  // 邮件
  public sendReport = {
    title: "",
    Sender: "",
    addressee: "",
    copy: "",
  };

  // 弹窗、表格 —— 游戏版本选择列表
  public get game_version_options() {
    const versions = this.getDateVersions.game_versions; //获取性能选择选项里的有些版本
    const game_version_select: any[] = [];
    versions.forEach((item) => {
      if (item.value) {
        game_version_select.push({
          label: item.label,
          value: item.value,
        });
      } else {
        game_version_select.push({
          label: "空版本",
          value: "null_version",
        });
      }
    });
    return game_version_select;
  }
  // 激活报告名称
  // public activation() {
  //   this.report_name_placeholder =
  //     "【GR自动化性能】" +
  //     this.get_project_name +
  //     " -" +
  //     this.generateReportVersion.newEdition.split("|")[0];
  // }

  // 得到项目名称
  public get get_project_name() {
    const project_name = readProjectDetail(store).project_name;
    return project_name;
  }
  // 生成报告
  public async generateReport() {
    if (
      this.generateReportVersion.oldEdition === "" ||
      this.generateReportVersion.newEdition === ""
    ) {
      alert("版本号不能为空哦！");
      return;
    }
    // if (
    //   this.generateReportVersion.oldEdition ===
    //   this.generateReportVersion.newEdition
    // ) {
    //   alert("版本号不能相同哦！");
    //   return;
    // }
    // if (
    //   this.generateReportVersion.oldEdition >
    //   this.generateReportVersion.newEdition
    // ) {
    //   alert("新版本号不能小于旧版本！");
    //   return;
    // }
    this.loading = true;
    this.dialogFormVisible = false;
    await dispatchCreateReport(store, {
      //调用创建报告的接口，将所需数据传递过去
      project: this.localProject,
      new_version: this.generateReportVersion.newEdition.split("|")[0],
      old_version: this.generateReportVersion.oldEdition.split("|")[0],
      timestamp: this.generateReportVersion.newEdition.split("|")[1],
      old_timestamp: this.generateReportVersion.oldEdition.split("|")[1], // 老版本截止日期
      // report_name: this.report_name_placeholder,
      scene_list: this.generateReportVersion.scenetion,
    });

    // 获取当前报告名称列表
    await dispatchGetNewReportList(store, {
      project: this.localProject,
      report_type: 0,
    });
    // 报告名称
    this.name_search = readNewReportList(store)[0].id;
    this.$router.push({
      query: { ...this.$route.query, report_id: this.name_search },
    });
    // 邮件标题
    this.formMail.title = (readNewReportList(store) as any[]).filter(
      (item: any) => item.id === this.name_search
    )[0].report_name;
    await dispatchGetReportDetail(store, {
      project: this.localProject,
      id: readNewReportList(store)[0].id,
    });
    await this.addressee; //解析邮件收件人

    this.report_id = readNewReport(store).id;
    await dispatchGetPerfReport(store, {
      project: this.localProject,
      report_id: readNewReportList(store)[0].id,
    });
    await this.perf_report();
    await this.get_create_report(); //启用生成报告的接口

    this.resBase64 = [];
    // aov数据
    await this.get_core_data.all_echart_data.map((item, index) => {
      this.performanceTrends_echarts(
        index,
        this.all_device_options[index].label
      ); //图表
      // console.log(this.all_device_options);
      // console.log(this.get_core_data.all_echart_data);
    });
    // dispatchGetPerformanceSelectOptions(store, {
    //   project: this.localProject,
    // });
    dispatchGetDateVersionList(store, {
      project: this.localProject,
    });
    dispatchGetDeviceSpecs(store, { project: this.localProject });
    await dispatchGetMobaProjects(store, this.localProject);
    if (this.projectIsKing) {
      dispatchGetHeroSkin(store, this.localProject);
    }
    await dispatchGetProjectScenes(store, { project: this.localProject });
    this.corePerformance = [];
    await this.getCorePerformance();
    await dispatchtaskRecordQuery(store, {
      project: this.localProject,
      task_record_id: "",
    }); //aov复制数据需要的任务记录列表接口
    await dispatchtaskRecordDevices(store, {
      project: this.localProject,
      task_record_id: "",
    }); //获取任务记录的设备
    this.get_core_data.report_list.unshift(this.get_core_data.report_list[0]);
    // await this.scrollBar()//判断是否有滚动条
    await this.noDecimal();
    await this.judgeModel;
    this.loading = false;
    this.dialogFormVisible = false;
  }

  //核心性能指标趋势

  //将新报告的JSON 字符串转换为对象。
  public get report_set() {
    const settings = JSON.parse(this.new_report.settings);
    return settings.report_settings;
  }

  // 数值变化的规则配置
  public get rule_set() {
    const settings = JSON.parse(this.new_report.settings);
    return settings.rule_settings;
  }

  // 趋势对比
  public compore_num(
    new_value: number,
    old_value: number,
    param: string,
    row?: any,
    device?: any
  ) {
    let level = device?.level;
    let device_type = device?.type;
    if (device_type === 0) {
      device_type = "Android";
    } else if (device_type === 1) {
      device_type = "iOS";
    }
    if (!new_value) {
      return ["", "", ""];
    }
    let res: any = 0;
    if (old_value) {
      res = parseFloat((new_value - old_value).toFixed(1));
    }
    let risk = "";
    let color = "";
    let color2 = "";
    let new_color = "";
    if (res !== 0) {
      // 风险判断,在increase_good中的上升标为绿色，下降为红色，如果配置有threshold，则变动超出阈值才标记颜色
      if (this.rule_set.change_rule.increase_good.includes(param)) {
        if (
          this.rule_set.risk_rule?.[param] &&
          this.report_set.content.core_index.includes(param)
        ) {
          if (
            (old_value - new_value) / old_value >
            this.rule_set.risk_rule?.[param]
          ) {
            risk = "高风险";
            this.com_risk = "高风险";
          }
        }

        // 按照设备的档位，类型判定风险, 判定规则：新版本数值超过阈值
        if (
          this.rule_set.tdr_risk_rule?.[device_type]?.["level_" + level]?.[
            param
          ] &&
          this.report_set.content.core_index.includes(param)
        ) {
          if (
            new_value <
            this.rule_set.tdr_risk_rule?.[device_type]?.["level_" + level]?.[
              param
            ]
          ) {
            risk = "高风险";
            this.com_risk = "高风险";
          }
        }

        if (this.rule_set.change_rule.threshold?.[param]) {
          if (
            Math.abs(new_value - old_value) / old_value >
            this.rule_set.change_rule.threshold?.[param]
          ) {
            color = "#606266";
            new_color = "red";
          } else {
            color = "#00b050";
            new_color = "#00b050";
          }
        } else {
          if (res > 0) {
            color = "#00b050";
            new_color = "#00b050";
          } else if (Math.abs(res) < 1) {
            color = "";
          } else {
            color = "#606266";
            new_color = "red";
          }
        }
      } else {
        if (
          this.rule_set.risk_rule?.[param] &&
          this.report_set.content.core_index.includes(param)
        ) {
          if (
            (new_value - old_value) / old_value >
            this.rule_set.risk_rule?.[param]
          ) {
            risk = "高风险";
            this.com_risk = "高风险";
          }
        }
        if (
          this.rule_set.tdr_risk_rule?.[device_type]?.["level_" + level]?.[
            param
          ] &&
          this.report_set.content.core_index.includes(param)
        ) {
          if (
            new_value >
            this.rule_set.tdr_risk_rule?.[device_type]?.["level_" + level]?.[
              param
            ]
          ) {
            risk = "高风险";
            this.com_risk = "高风险";
          }
        }

        if (this.rule_set.change_rule.threshold?.[param]) {
          if (
            Math.abs(new_value - old_value) / old_value >
            this.rule_set.change_rule.threshold?.[param]
          ) {
            color = "#606266";
            new_color = "red";
          } else {
            color = "#00b050";
            new_color = "#00b050";
          }
        } else {
          if (res > 1) {
            color = "#606266";
            new_color = "red";
          } else if (res > 0) {
            color = "";
          } else {
            color = "#00b050";
            new_color = "#00b050";
          }
        }
      }
      if (param === "Tris" || param === "Verts") {
        res = Math.round(res);
      }
      // 指标变化规则判断
      if (row) {
        if (res > 0) {
          res = "(" + Math.abs(res) + "↑" + ")";
        } else if (res < 0) {
          res = "(" + Math.abs(res) + "↓" + ")";
        }
      } else {
        if (res > 0) {
          res = Math.abs(res) + "↑";
        } else if (res < 0) {
          res = Math.abs(res) + "↓";
        }
      }
    } else {
      if (this.rule_set.change_rule.increase_good.includes(param)) {
        // 按照设备的档位，类型判定风险, 判定规则：新版本数值超过阈值
        if (
          this.rule_set.tdr_risk_rule?.[device_type]?.["level_" + level]?.[
            param
          ] &&
          this.report_set.content.core_index.includes(param)
        ) {
          if (
            new_value <
            this.rule_set.tdr_risk_rule?.[device_type]?.["level_" + level]?.[
              param
            ]
          ) {
            risk = "高风险";
            this.com_risk = "高风险";
          }
        }
      } else {
        if (
          this.rule_set.tdr_risk_rule?.[device_type]?.["level_" + level]?.[
            param
          ] &&
          this.report_set.content.core_index.includes(param)
        ) {
          if (
            new_value >
            this.rule_set.tdr_risk_rule?.[device_type]?.["level_" + level]?.[
              param
            ]
          ) {
            risk = "高风险";
            this.com_risk = "高风险";
          }
        }
      }
      res = row ? "(--)" : "";
    }

    if (risk === "高风险" && row) {
      row[param] = "高风险";
      if (!this.report_set.content.red_only_change_value) {
        color2 = "color:red;font-weight: bold;";
      }
      color = "red;font-weight: bold;";
    } else {
      risk = "低风险";
    }
    return [res, risk, color, color2, new_color];
  }

  //趋势图

  //性能指标初始化
  public selected_target = this.report_set.content.trend_index[0] || "";
  //获取场景iD
  public selected_scene =
    (this.get_core_data.all_echart_data as any[])[0]?.scene_id || "";
  public get get_scene_chinese() {
    return (
      this.scene_options.filter(
        (item) => item.scene_id === this.selected_scene
      )[0]?.chinese || "-"
    );
  }
  // 获取是否是moba项目
  public get is_in_moba_project() {
    const moba = readMobaProjects(store);
    return moba;
  }
  // 项目是否是王者荣耀
  public get projectIsKing() {
    //9
    if ((this.is_in_moba_project as any).includes(this.localProject)) {
      return true;
    } else {
      return false;
    }
  }
  public get_device_label(devie: string, index: number) {
    if (
      this.projectIsKing &&
      Object.keys(this.get_core_data.all_hero_skins).length !== 0
    ) {
      const hero =
        (this.get_hero_skin_config.skin_list as any[]).filter(
          (item) =>
            Number(item.hero_id) ===
            this.get_core_data.all_hero_skins?.[devie].hero_id
        )[0]?.hero_name || "无英雄";
      const skin =
        (this.get_hero_skin_config.skin_list as any[]).filter(
          (item) =>
            Number(item.skin_id) ===
              this.get_core_data.all_hero_skins?.[devie].hero_id &&
            Number(item.hero_id) ===
              this.get_core_data.all_hero_skins?.[devie].skin_id
        )[0]?.skin_name || "无皮肤";
      return devie + "\n" + hero + "-" + skin;
    } else {
      // return devie.split('(')[1].split(')')[0] + "\n" + devie.split('(')[0];
      return devie;
    }
  }
  //场景选项
  public get scene_options() {
    const scene = readPerfReport(store).all_echart_data; //性能报告数据
    var sceneOptions: any[] = []; //场景
    for (let i in scene) {
      sceneOptions.push({
        scene_id: scene[i].scene_id,
        chinese: scene[i].scene,
      });
    }
    return sceneOptions;
  }
  // 指标选项
  public get target_types() {
    let target_select: any[] = [];
    this.report_set.content.trend_index.forEach((item: any) => {
      target_select.push({
        label: this.get_field(item),
        value: item,
      });
    });
    return target_select;
  }
  //点击切换场景时触发
  public async selectSceneChange() {
    this.resBase64 = [];
    this.target_types.map((item, index) => {
      this.drawPieChart(index, item.value);
    });
  }
  //点击切换指标时触发
  public selectChange() {
    this.resBase64 = [];
    this.target_types.map((item, index) => {
      this.drawPieChart(index, item.value);
    });
  }
  //绘制图表准备
  // 原始数据处理
  public get getFPS_RawData() {
    const FPS_RawData: any[] = (this.get_core_data
      .all_echart_data as any[]).filter(
      (item: any) => item.scene_id === this.selected_scene
    )[0]?.echart_data;
    return FPS_RawData;
  }
  // 绘制图表
  public drawPieChart(index: any, indexes: string) {
    // 横坐标，版本列表
    const game_versions = unique_json(this.getFPS_RawData, "game_version")
      .map((item) => item.game_version)
      .sort();
    let devices = unique_json(this.getFPS_RawData, "device_id"); // 用于生成去重的设备UUID列表
    devices = devices.filter((item) =>
      (this.get_core_data.all_device_id as any).includes(item.device_id)
    );
    // 数据
    let itemstyle_normal = false;
    const ordinates: any[] = [];
    if (devices.length <= 3) {
      itemstyle_normal = true;
    }
    devices.forEach((item) => {
      const device = this.getDeviceSpecs.filter(
        (device) => device.id === item.device_id
      )[0];
      ordinates.push({
        name: device?.model.name,
        id: item.device_id,
        type: "line",
        data: [],
        cache: [],
        smooth: true,
        itemStyle: { normal: { label: { show: itemstyle_normal } } },
      });
    });
    // cache里存放的是完整的数据，但已经按照设备过滤
    ordinates.forEach((device) => {
      this.getFPS_RawData.forEach((item) => {
        if (item.device_id === device.id) {
          device.cache.push(item);
        }
      });
    });

    // 纵坐标填充值，将没有数据的横坐标节点填充为空,eg：[1, 2, 3, 4, 6] => [1, 2 , 3, 4, "", 6]
    ordinates.forEach((device) => {
      game_versions.forEach((version) => {
        const item = (device.cache as any[]).filter(
          (item) => item.game_version === version
        )[0]?.[this.target_types[index].value];
        if (item || item === 0 || item === "0") {
          device.data.push(item);
        } else {
          device.data.push("");
        }
      });
    });
    let yAxisSetting: any = {
      type: "value",
      offset: 10,
      axisLabel: {
        formatter: "{value}",
      },
      min: function (value: any) {
        return Math.ceil(value.min * 0.7);
      },
      max: function (value: any) {
        return Math.ceil(value.max * 1.05);
      },
    };
    if (indexes === "lag_pcnt") {
      yAxisSetting = {
        type: "value",
        offset: 10,
        axisLabel: {
          formatter: "{value}",
        },
        max: function (value: any) {
          return Math.ceil(value.max * 1.05);
        },
      };
    }

    let performance_line: any = document.getElementById(
      "performance_line" + index
    );
    let toolbox: any = {
      feature: {
        saveAsImage: {},
      },
    };
    if ("screenshot" in this.$route.query) {
      toolbox = {};
    }

    let legend_remark = devices.map(
      (item) =>
        this.getDeviceSpecs.filter((device) => device.id === item.device_id)[0]
          ?.remark
    );
    let legend_name = devices.map(
      (item) =>
        this.getDeviceSpecs.filter((device) => device.id === item.device_id)[0]
          ?.model.name
    );
    // 用echarts时，如果存在DOM，就会报存在警告，处理方法删除DOM
    // echarts数据变动时, 数据正常，图标混乱，故以此解决
    echarts.dispose(performance_line);
    let PerformanceLineChart = echarts.init(performance_line);
    let option;
    option = {
      title: {
        left: "center",
        textStyle: {
          fontSize: 16,
          fontWeight: "normal",
        },
      },
      tooltip: {
        trigger: "axis",
      },
      legend: {
        x: "center",
        y: "bottom",
        padding: [0, 0, 10, 0],
        data: devices.map(
          (item) =>
            this.getDeviceSpecs.filter(
              (device) => device.id === item.device_id
            )[0]?.model.name
        ),
      },
      grid: {
        left: "4%",
        top: "10%",
        bottom: "20%",
        right: "4%",
        containLabel: true,
      },
      toolbox: toolbox,
      animation: false,
      xAxis: {
        type: "category",
        boundaryGap: false,
        data: game_versions,
        offset: 10,
      },
      yAxis: yAxisSetting,
      series: ordinates,
    };
    PerformanceLineChart.setOption(option);
    var res_base64 = PerformanceLineChart.getDataURL({
      excludeComponents: ["toolbox"],
    }); //拿到base64 地址，就好下载了。
    let res: any = {};
    res.file_base64 = res_base64;
    res.filename = "report" + index + ".png";
    res.scene_chinese = this.scene_options.filter(
      (item) => item.scene_id === this.selected_scene
    )[0].chinese;
    res.indexes = this.get_field(indexes);
    this.resBase64.push(res);

    return PerformanceLineChart;
  }

  // 详细测试数据

  // 索引分类
  public indexClassification(custom_index: string[]) {
    const settings = JSON.parse(this.new_report.settings);
    const index = settings.report_settings.content.index_type;
    let indexClassification: any[] = [];
    indexClassification.push({
      indexClassification: "指标分类",
      dataItem: "数据项",
    });
    (index.basic as any[]).forEach((item) =>
      indexClassification.push({
        indexClassification: "基础指标",
        dataItem: this.get_field(item),
        style: { "background-color": "#51792e" },
      })
    );
    (index.advance as any[]).forEach((item) =>
      indexClassification.push({
        indexClassification: "深度指标",
        dataItem: this.get_field(item),
        style: { "background-color": "#fdc108" },
      })
    );
    (index.customize as any[]).forEach((item) =>
      indexClassification.push({
        indexClassification: "定制指标",
        dataItem: this.get_field(item),
        style: { "background-color": "#ef7b2a" },
      })
    );
    custom_index.forEach((item) =>
      indexClassification.push({
        indexClassification: "定制指标",
        dataItem: item,
        style: { "background-color": "#ef7b2a" },
      })
    );
    return indexClassification;
  }

  // 链接
  public get_url(url: string) {
    let new_url = url;
    if (url) {
      let url_arr = url.split("/");
      if (url_arr[2] !== "runmax.oa.com") {
        let current_herf = window.parent.location.href;
        let f = current_herf.split("/");
        let domain = f[2];
        url_arr[2] = domain;
        new_url = url_arr.join("/");
        return new_url;
      }
    }
    return url;
  }
  public game_scene_version = [];
  public get getDateVersionsList() {
    return readPerformanceVersion(store);
  }
  public async selectVersion() {
    await dispatchGetPerformanceVersion(store, {
      project: this.localProject,
      version: (this.generateReportVersion.newEdition as any).split("|")[0],
      timestamp:
        (this.generateReportVersion.newEdition as any).split("|")[1] || "",
    });
    this.game_scene_version = this.getDateVersionsList.scene_list;
  }
  // 获取所有的索引
  public all_index(custom_index: string[]) {
    const settings = JSON.parse(this.new_report.settings);
    const index = settings.report_settings.content.index_type;
    let indexs = [];
    indexs.push(...index.basic);
    indexs.push(...index.advance);
    indexs.push(...index.customize);
    indexs.push(...custom_index);
    return indexs;
  }

  public time: any = "";
  public reload() {
    this.time = new Date().getTime();
  }

  public Level: any[] = [
    { label: "超高端机", value: 0 },
    { label: "高端机", value: 1 },
    { label: "中端机", value: 2 },
    { label: "低端机", value: 3 },
    { label: "超低端机", value: 4 },
  ];
  // 设备
  public get all_device_options() {
    const devices = this.get_core_data.all_echart_data;
    const device_select: any[] = [];
    devices.forEach((item) => {
      const device = this.getDeviceSpecs.filter(
        (device) => device.id === item.performance_briefs[0]?.device_id
      )[0];
      let name =
        this.Level.filter((item3) => item3.value === device?.level)[0]?.label +
        device?.model?.name;
      device_select.push({
        label: name,
        value: item,
      });
    });
    return device_select;
  }

  // 图表
  public performanceTrends_echarts(index: any, titleVal: any) {
    let legendVal: any[] = [
      "max_pss",
      "avg_fps",
      "monomem",
      // "Jank(/10min)",
      "avg_dc",
      "loadingtime",
      "FrameSync",
    ];
    let legendVal2: any[] = [
      "PSS峰值",
      "平均FPS",
      "Mono堆内存峰值",
      // "卡顿次数(10m)",
      "Drawcall均值",
      "loading时间均值",
      "FrameSync",
    ];
    let seriesData: any[] = [];
    let newArr: any[] = [];
    // 数据处理
    this.get_core_data.all_echart_data[index]?.performance_briefs.forEach(
      (item: any) => {
        if (item.custom_data !== undefined) {
          newArr.push({ ...item, ...JSON.parse(item.custom_data) });
          newArr.map((item: any) => {
            if (
              item.avg_dc === "" ||
              item.avg_dc === null ||
              item.avg_dc === undefined
            ) {
              item.avg_dc = item.dc;
            }
          });
        }
      }
    );

    let seriesDataValue: any[] = [];

    legendVal.forEach((item: any, index) => {
      let data_list = getAttrs(newArr, item);

      let arr_deal = get_data_new(data_list, index);
      let arr_new = arr_deal["arr_new"];
      let arr_new_map = arr_deal["arr_new_map"];

      let value_deal = get_avg(data_list);
      seriesDataValue.push({
        value_avg: value_deal["avg"],
        value_y_max: 0,
        value_y_min: 0,
        value_index: index,
        value_max: value_deal["max"],
        value_min: value_deal["min"],
        data_list: data_list,
        arr_new: arr_new,
        arr_new_map: arr_new_map,
      });

      seriesData.push({
        name: legendVal2[index],
        type: "line",
        data: arr_new,
        yAxisIndex: index,
        symbol: "circle", //拐点设置为实心
        symbolSize: 8, //拐点大小
        label: {
          show: true,
          formatter: function (data: any) {
            return arr_new_map.get(data.value);
          },
        },
      });
    });

    seriesDataValue.forEach((item, index) => {
      let avg = item["value_avg"];

      let value_y_max = avg * (12 / (11 - 2 * index));
      let value_y_min = 0;

      seriesDataValue[index]["value_y_max"] = value_y_max;
      seriesDataValue[index]["value_y_min"] = value_y_min;
    });
    // console.log(seriesDataValue)

    // 计算一个数组的平均值，最大值，最小值
    function get_avg(array: any) {
      let sum = 0;
      array.forEach((item: string) => {
        let tmp = parseFloat(item);
        sum += tmp;
      });
      return {
        avg: sum / array.length,
        max: Math.max(...array),
        min: Math.min(...array),
      };
    }

    // 把数组里面的值，通过变换，映射到平均值附近
    function get_data_new(array: any, index: any) {
      let value_deal = get_avg(array);
      let value_avg = value_deal["avg"];
      let value_max = value_deal["max"];
      let value_min = value_deal["min"];

      let arr_new: any[] = [];
      let arr_new_map = new Map();
      let rat = 1 / (11 - 2 * index);

      if (value_max < (1 + rat) * value_avg) {
        value_max = (1 + rat) * value_avg;
      }

      if (value_min > (1 - rat) * value_avg) {
        value_min = (1 - rat) * value_avg;
      }

      array.forEach((item: string) => {
        let value = parseFloat(item);
        let value_new = value;
        if (value > value_avg) {
          value_new =
            (1 +
              ((rat * (value - value_avg)) / (value_max - value_avg)) * 0.9) *
            value_avg;
          arr_new.push(value_new);
        } else {
          value_new =
            (1 -
              ((rat * (value_avg - value)) / (value_avg - value_min)) * 0.9) *
            value_avg;
          arr_new.push(value_new);
        }

        arr_new_map.set(value_new, value);
      });
      return { arr_new: arr_new, arr_new_map: arr_new_map };
    }

    function getAttrs(array: any, attr: any) {
      var arr = array.map((item: any) => {
        return item[attr];
      });
      arr.map((item2: any, index: any) => {
        if (
          arr[index] === undefined ||
          arr[index] === null ||
          arr[index] === ""
        ) {
          arr[index] = "--";
        }
      });
      return arr;
    }
    let performanceTrends: any = document.getElementById(
      "Performance_trends" + index
    );
    echarts.dispose(performanceTrends);
    let PerformanceLineChart = echarts.init(performanceTrends);
    let option;
    option = {
      title: {
        text: titleVal,
        x: "center",
        textStyle: {
          fontWeight: "normal",
          fontSize: 15,
        },
      },
      tooltip: {
        show: true,
        trigger: "axis",
        formatter: (params: any) => {
          let tip = "";
          if (params != null && params.length > 0) {
            for (let i = 0; i < params.length; i++) {
              let value = seriesDataValue[params[i].seriesIndex][
                "arr_new_map"
              ].get(params[i].value);
              // tip +=  params[i].marker + ' ' + params[i].seriesName + ":" + seriesDataValue[params[i].seriesIndex]['arr_new_map'].get(params[i].value) + "</br>"
              tip +=
                "<div>" +
                "<p>" +
                params[i].marker +
                " " +
                params[i].seriesName +
                "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;" +
                '<span style="font-weight: bold;float: right;">' +
                value +
                "</span>" +
                "</p>" +
                "</div>";
            }
          }
          return tip;
        },
      },
      legend: {
        x: "center",
        y: "bottom",
        data: legendVal2,
      },
      grid: {
        left: "2%",
        right: "-100",
        bottom: "10%",
        top: "15%",
        containLabel: true,
      },
      toolbox: {
        feature: {
          saveAsImage: {},
        },
      },
      xAxis: {
        type: "category",
        boundaryGap: false,
        data: this.get_core_data.all_echart_data[index]?.date_list,
        offset: 10,
      },
      yAxis: [
        {
          show: false,
          // offset: 10,
          name: "PSS峰值",
          type: "value",
          min: seriesDataValue[0]["value_y_min"],
          max: seriesDataValue[0]["value_y_max"],
          position: "right",
          axisLabel: {
            formatter: function (v: any) {
              return parseInt(v); //表示整数。其他数值类型以此类推
            },
          },
        },
        {
          show: false,
          // offset: 10,
          name: "平均FPS",
          type: "value",
          min: seriesDataValue[1]["value_y_min"],
          max: seriesDataValue[1]["value_y_max"],
          position: "left",
          axisLabel: {
            formatter: function (v: any) {
              return parseInt(v); //表示整数。其他数值类型以此类推
            },
          },
        },
        {
          show: false,
          // offset: 10,
          name: "Mono内存峰值",
          type: "value",
          min: seriesDataValue[2]["value_y_min"],
          max: seriesDataValue[2]["value_y_max"],
          position: "right",
          axisLabel: {
            formatter: function (v: any) {
              return parseInt(v); //表示整数。其他数值类型以此类推
            },
          },
        },
        {
          show: false,
          // offset: 10,
          name: "DrawCall均值",
          type: "value",
          min: seriesDataValue[3]["value_y_min"],
          max: seriesDataValue[3]["value_y_max"],
          position: "right",
          axisLabel: {
            formatter: function (v: any) {
              return parseInt(v); //表示整数。其他数值类型以此类推
            },
          },
        },
        // {
        //   show: false,
        //   // offset: 10,
        //   name: "卡顿次数",
        //   type: "value",
        //   min: seriesDataValue[2]['value_y_min'],
        //   max: seriesDataValue[2]['value_y_max'],
        //   position: 'right',
        //   axisLabel: {
        //     formatter: function (v: any) {
        //       return parseInt(v); //表示整数。其他数值类型以此类推
        //     },
        //   },
        // },
        {
          show: false,
          // offset: 10,
          name: "loading时间均值",
          type: "value",
          min: seriesDataValue[4]["value_y_min"],
          max: seriesDataValue[4]["value_y_max"],
          position: "right",
          axisLabel: {
            formatter: function (v: any) {
              return parseInt(v); //表示整数。其他数值类型以此类推
            },
          },
        },
        {
          show: false,
          // offset: 10,
          name: "FrameSync",
          type: "value",
          min: seriesDataValue[5]["value_y_min"],
          max: seriesDataValue[5]["value_y_max"],
          position: "right",
          axisLabel: {
            formatter: function (v: any) {
              return parseInt(v); //表示整数。其他数值类型以此类推
            },
          },
        },
      ],
      series: seriesData,
      animation: false,
    };
    PerformanceLineChart.setOption(option);
    var res_base64 = PerformanceLineChart.getDataURL({
      excludeComponents: ["toolbox"],
    }); //拿到base64 地址，就好下载了。
    let res: any = {};
    res.file_base64 = res_base64;
    // res.filename = "aov" + index + ".png";
    res.filename =
      "aov" +
      index +
      "_project" +
      this.localProject +
      "_report" +
      this.$route.query.report_id +
      ".png";
    this.resBase64.push(res);
    return PerformanceLineChart;
  }

  // aov测试数据
  public testData = [
    {
      label: "平均FPS",
      value: "avg_fps",
    },
    {
      label: "loading时间均值",
      value: "loadingtime",
    },
    {
      label: "帧率>18比例(%)",
      value: "fps_lt_18_pcnt",
    },
    {
      label: "帧率>25比例(%)",
      value: "fps_lt_25_pcnt",
    },
    {
      label: "帧率方差",
      value: "Var(FPS)",
    },
    {
      label: "单帧>100ms比例(%)",
      value: "FTime>=100[%]",
    },
    {
      label: "卡顿次数(10m)",
      value: "Jank(/10min)",
    },
    {
      label: "严重卡顿次数(10m)",
      value: "BigJank(/10min)",
    },
    {
      label: "PSS内存均值(MB)",
      value: "Avg(Memory)[MB]",
    },
    {
      label: "PSS内存峰值(MB)",
      value: "max_pss",
    },
    {
      label: "Mono已用内存峰值(MB)",
      value: "monomem",
    },
    {
      label: "Mono堆内存峰值(MB)",
      value: "avg_monomem",
    },
    {
      label: "GC次数",
      value: "gc",
    },
    {
      label: "DrawCall均值",
      value: "avg_dc",
    },
    {
      label: "三角形数均值",
      value: "Tris",
    },
    {
      label: "顶点数均值",
      value: "Verts",
    },
    {
      label: "UI_dc",
      value: "UI_dc",
    },
    {
      label: "HUD_dc",
      value: "HUD_dc",
    },
    {
      label: "Scene_dc",
      value: "Scene_dc",
    },
    {
      label: "Particle_dc",
      value: "Particle_dc",
    },
    {
      label: "FrameSync",
      value: "FrameSync",
    },
    {
      label: "LogicThr",
      value: "LogicThr",
    },
    {
      label: "SleepTime",
      value: "SleepTime",
    },
    {
      label: "PostTime",
      value: "PostTime",
    },
    {
      label: "平均CPU",
      value: "avg_cpu",
    },
    {
      label: "最高温度",
      value: "max_cpu_temp",
    },
  ];

  // 判断是否是管理员
  public get get_is_super() {
    let judge = true;
    let MyProject = readMyProjects(store).filter(
      (item: any) => item.project.id == this.localProject
    )[0]?.is_project_admin;
    if (readUserProfile(store)?.is_super) {
      judge = false;
    } else if (MyProject) {
      judge = false;
    } else {
      judge = true;
    }
    return judge;
  }

  // 复制数据
  public copyVal = {
    taskRecordId: "", //任务记录id
    deviceVal: "", //任务记录设备
  };
  // 获取复制需要的任务id下拉框
  public get TaskRecordQuery() {
    return readTaskRecordQuery(store);
  }

  // 获取复制需要的设备数据下拉框
  public get TaskRecordDevices() {
    return readTaskRecordDevices(store);
  }
  // 切换复制的id时，更新设备数据
  public async equipmentUpdate() {
    await dispatchtaskRecordDevices(store, {
      project: this.localProject,
      task_record_id: Number(this.copyVal.taskRecordId),
    });
  }

  // 复制接口禁用
  public get interfaceDisabled() {
    let disabled = false;
    if (
      this.get_is_super ||
      this.copyVal.taskRecordId === "" ||
      this.copyVal.deviceVal === "" ||
      this.copyVal.deviceVal === undefined
    ) {
      disabled = true;
    }
    return disabled;
  }
  //复制的接口
  public async CopyBtn() {
    this.loading = true;
    let copy = {
      project: this.localProject,
      task_record_id: this.copyVal.taskRecordId,
      device_id: this.copyVal.deviceVal,
      // report_id: Number(this.$route.query.report_id),
      report_id: Number(this.name_search),
    };
    await dispatchAovCopyPerfToReport(store, copy);
    await dispatchGetReportDetail(store, {
      project: this.localProject,
      id: Number(this.$route.query.report_id),
    });

    this.resBase64 = [];
    // aov数据
    await this.get_core_data.all_echart_data.map((item, index) => {
      this.performanceTrends_echarts(
        index,
        this.all_device_options[index].label
      ); //图表
    });

    this.loading = false;
  }

  // 小数
  public noDecimal() {
    let decimal = [
      "Avg(Memory)[MB]",
      "max_pss",
      "monomem",
      "avg_monomem",
      "Tris",
      "Verts",
    ];
    decimal.forEach((item: any) => {
      this.getnoDecimal("new", item);
      this.getnoDecimal("old", item);
      this.getnoDecimal("standard", item);
    });
  }
  public async clear() {
    await dispatchClearCache(store, {
      project: this.localProject,
      report_id: Number(this.name_search),
    });
    await dispatchGetPerfReport(store, {
      project: this.localProject,
      report_id: Number(this.name_search),
    });
  }
  public getnoDecimal(val1: any, val2: any) {
    this.get_core_data.report_list2.map((item: any) =>
      item[val1].map((item2: any) => {
        if (val1 === "standard") {
          if (
            item2[val2] === undefined ||
            item2[val2] === null ||
            item2[val2] === ""
          ) {
            item2[val2] = "--";
          } else {
            item2[val2] = Math.round(item2[val2]);
          }
        } else {
          if (
            item2.data[val2] === undefined ||
            item2.data[val2] === null ||
            item2.data[val2] === ""
          ) {
            item2.data[val2] = "--";
          } else {
            item2.data[val2] = Math.round(item2.data[val2]);
          }
        }
      })
    );
  }
  // 判断安卓/ios
  public modelVal = "安卓";
  public get judgeModel() {
    // this.get_core_data.able_versions.android_new_version = "";
    // this.get_core_data.able_versions.android_old_version = "";
    // this.get_core_data.able_versions.ios_new_version = "11";
    // this.get_core_data.able_versions.ios_old_version = "22";
    let ad_new = this.get_core_data.able_versions.android_new_version;
    let ad_old = this.get_core_data.able_versions.android_old_version;
    let ios_new = this.get_core_data.able_versions.ios_new_version;
    let ios_old = this.get_core_data.able_versions.ios_old_version;
    if (
      (ad_new !== "" || ad_old !== "") &&
      (ios_new !== "" || ios_old !== "")
    ) {
      this.modelVal = "安卓/iOS";
    } else if (ios_new !== "" || ios_old !== "") {
      this.modelVal = "iOS";
    }
    return this.modelVal;
  }
  //获取报告名称的列表
  public get nameList() {
    let name_list: any[] = [];
    name_list = readNewReportList(store);
    return name_list;
  }
  // 邮件
  public edit = false;
  public formMail = {
    title: "", //标题
    Sender: "gamerobot@tencent.com", //发件人
    addressee: "", //收件人
    CC_List: "", //抄送人
  };

  // 点击发送
  public sendOut() {
    this.edit = !this.edit;
  }

  // 解析邮件收件人
  public get addressee() {
    let addressee = JSON.parse(readNewReport(store).settings).report_settings
      .notify.email.receiver_str;
    this.formMail.addressee = addressee;

    return addressee;
  }

  // 报告名称切换时
  public async change_name_search() {
    this.loading = true;
    // 获取当前报告名称列表
    await dispatchGetNewReportList(store, {
      project: this.localProject,
      report_type: 0,
    });
    // 报告名称
    // this.name_search = readNewReportList(store)[0].id;
    this.$router.push({
      query: { ...this.$route.query, report_id: this.name_search },
    });
    // 邮件标题
    this.formMail.title = (readNewReportList(store) as any[]).filter(
      (item: any) => item.id === this.name_search
    )[0].report_name;
    await dispatchGetReportDetail(store, {
      project: this.localProject,
      id: Number(this.name_search),
    });
    await this.addressee; //解析邮件收件人

    this.report_id = readNewReport(store).id;
    await dispatchGetPerfReport(store, {
      project: this.localProject,
      report_id: Number(this.name_search),
    });
    await this.perf_report();
    await this.get_create_report(); //启用生成报告的接口

    this.resBase64 = [];
    // aov数据
    await this.get_core_data.all_echart_data.map((item, index) => {
      this.performanceTrends_echarts(
        index,
        this.all_device_options[index].label
      ); //图表
      // console.log(this.all_device_options);
      // console.log(this.get_core_data.all_echart_data);
    });
    dispatchGetDateVersionList(store, {
      project: this.localProject,
    });
    // dispatchGetPerformanceSelectOptions(store, {
    //   project: this.localProject,
    // });
    dispatchGetDeviceSpecs(store, { project: this.localProject });
    await dispatchGetMobaProjects(store, this.localProject);
    if (this.projectIsKing) {
      dispatchGetHeroSkin(store, this.localProject);
    }
    await dispatchGetProjectScenes(store, { project: this.localProject });
    this.corePerformance = [];
    await this.getCorePerformance();
    await dispatchtaskRecordQuery(store, {
      project: this.localProject,
      task_record_id: "",
    }); //aov复制数据需要的任务记录列表接口
    await dispatchtaskRecordDevices(store, {
      project: this.localProject,
      task_record_id: "",
    }); //获取任务记录的设备
    this.get_core_data.report_list.unshift(this.get_core_data.report_list[0]);
    // await this.scrollBar()//判断是否有滚动条
    await this.noDecimal();
    await this.judgeModel;
    this.loading = false;
  }
  // 点击删除
  public async handleDelete() {
    this.loading = true;
    await dispatchDeleteReport(store, {
      project: this.localProject,
      report_id: Number(this.name_search),
      page: 1,
      size: 1,
      report_name: "",
      new_version: "",
      old_version: "",
      risk: "",
      creator: "",
    });
    // 获取当前报告名称列表
    await dispatchGetNewReportList(store, {
      project: this.localProject,
      report_type: 0,
    });
    // 报告名称
    this.name_search = readNewReportList(store)[0].id;
    this.$router.push({
      query: { ...this.$route.query, report_id: this.name_search },
    });
    // 邮件标题
    this.formMail.title = (readNewReportList(store) as any[]).filter(
      (item: any) => item.id === this.name_search
    )[0].report_name;
    await dispatchGetReportDetail(store, {
      project: this.localProject,
      id: Number(this.name_search),
    });
    await this.addressee; //解析邮件收件人

    this.report_id = readNewReport(store).id;
    await dispatchGetPerfReport(store, {
      project: this.localProject,
      report_id: Number(this.name_search),
    });
    await this.perf_report();
    await this.get_create_report(); //启用生成报告的接口

    this.resBase64 = [];
    // aov数据
    await this.get_core_data.all_echart_data.map((item, index) => {
      this.performanceTrends_echarts(
        index,
        this.all_device_options[index].label
      ); //图表
      // console.log(this.all_device_options);
      // console.log(this.get_core_data.all_echart_data);
    });
    // dispatchGetPerformanceSelectOptions(store, {
    //   project: this.localProject,
    // });
    dispatchGetDateVersionList(store, {
      project: this.localProject,
    });
    dispatchGetDeviceSpecs(store, { project: this.localProject });
    await dispatchGetMobaProjects(store, this.localProject);
    if (this.projectIsKing) {
      dispatchGetHeroSkin(store, this.localProject);
    }
    await dispatchGetProjectScenes(store, { project: this.localProject });
    this.corePerformance = [];
    await this.getCorePerformance();
    await dispatchtaskRecordQuery(store, {
      project: this.localProject,
      task_record_id: "",
    }); //aov复制数据需要的任务记录列表接口
    await dispatchtaskRecordDevices(store, {
      project: this.localProject,
      task_record_id: "",
    }); //获取任务记录的设备
    this.get_core_data.report_list.unshift(this.get_core_data.report_list[0]);
    // await this.scrollBar()//判断是否有滚动条
    await this.noDecimal();
    await this.judgeModel;
    this.loading = false;
  }
}
